export const contactType = {
	MOBILE: 1,
	HOME: 2,
	WORK_OFFICE: 3,
	EMAIL: 4
};
